import { CultureInfo } from '../culture-info.model';
import { CultureInfoEn } from './en';

/**
 * @ignore
 */
export const CultureInfoEnIS: CultureInfo = {
  name: 'en-IS',
  displayName: 'English (Iceland)',
  iso3LanguageCode: 'eng',
  iso2LanguageCode: 'en',
  ietfLanguageTag: 'en-IS',
  parent: CultureInfoEn
};
